import { useState, useEffect } from 'react';
import { CardData } from '../../types';

export const useCardNavigation = (groupedCards: CardData[] | undefined, isSelected: boolean) => {
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isSelected) {
      setCurrentCardIndex(0);
    }
  }, [isSelected]);

  const navigateToPrevCard = () => {
    if (groupedCards && groupedCards.length > 1) {
      setIsLoading(true);
      setTimeout(() => {
        setCurrentCardIndex((prev) =>
          prev === 0 ? groupedCards.length - 1 : prev - 1
        );
        setIsLoading(false);
      }, 200);
    }
  };

  const navigateToNextCard = () => {
    if (groupedCards && groupedCards.length > 1) {
      setIsLoading(true);
      setTimeout(() => {
        setCurrentCardIndex((prev) =>
          prev === groupedCards.length - 1 ? 0 : prev + 1
        );
        setIsLoading(false);
      }, 200);
    }
  };

  return {
    currentCardIndex,
    isLoading,
    navigateToPrevCard,
    navigateToNextCard
  };
};